import { code } from "@spscommerce/utils";

export const SpsSearchResultsBarExamples = {
    noCount: {
        label: "Basic ",
        description: `<p>Info about Basic Search Result Bars</p>`,
        examples: {
            noCount: {
                template: code`
                <sps-search-results-bar (clear)="onClear()">
                </sps-search-results-bar>
                `
            }
        }
    },
    withCount: {
        label: "With Count",
        description: `<p>Info about Search Result Bars with count bars</p>`,
        examples: {
            withCount: {
                template: code`
                <sps-search-results-bar resultsCount="123" (clear)="onClear()">
                </sps-search-results-bar>
                `
            }
        }
    },
    withCountAndTotal: {
        label: "Count & Total ",
        description: `<p> Info about Search Result Bars with count & total</p>`,
        examples: {
            withCountAndTotal: {
                template: code`
                <sps-search-results-bar resultsCount="123" totalResults="456" (clear)="onClear()">
                </sps-search-results-bar>
                `
            }
        }
    }
};
